import { Injectable } from '@angular/core';
import * as io from "socket.io-client";
import { BehaviorSubject } from 'rxjs';

export interface NCIDInfo {
	ncidtype: string;
	date?: string;
	nmbr?: string; // trapped with -, make sure to strip
	mesg?: string;
	name?: string;
	time?: string;
}

export class CallLog {
	
	name: string;
	number: string;
	date: Date;

	constructor(p: NCIDInfo) {
		const d = p.date.split('-').map(this._toNumber), // mm-dd-yy
			t = p.time.split('').map(this._toNumber); // hh:nn

		this.name = p.name || 'unknown';
		this.number = p.nmbr.replace(/[^0-9.]/g, "");
		this.date = new Date(2000 + d[2], d[0] - 1, d[1], t[0], t[1])
	}

	private _toNumber(str: string): number {
		return +str;
	}
}

@Injectable({
  providedIn: 'root'
})
export class CallerIdService {

	protected connected = new BehaviorSubject<boolean>(false);
	calls = new BehaviorSubject<CallLog>(null);

	defaultHost = 'http://localhost:3000';

	constructor() {
		this._init('10.10.254.154:3000');
		// emulate an initial call from my own phone number
	}

	private _init(host: string = this.defaultHost) {

		const s = io(host, {
			reconnectionDelay: 10000,
			reconnectionDelayMax: 30000
		});

		s.on('connect', () => {

			console.log('callerid is listening', {host, this: this});

			// inform that we have connected
			this.connected.next(true);

			// spin up our listener
			s.on('ncidInfo', (msg: string)  => {
				const params: NCIDInfo = JSON.parse(msg);
				if (params.ncidtype === 'CID') {
					const call = new CallLog(params);
					this.calls.next(call);
				}
			});

		});

		s.on('connect_error', () => {
			
			if (host !== this.defaultHost) {
				console.warn(`callerid error\n'${host}' not found, attempting with default '${this.defaultHost}`);
				s.disconnect();
				this._init(this.defaultHost);
			} else {
				this.connected.next(false);
			}
		});
	}
}
